<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            RETRATOS <br>
            FAMILIARES
        </p>
        <p class="fontMS100 colorPrincipal font-45"></p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio30/RETRATOS-000.jpg">
</section>
<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS700 text-center font-24 mb-0">
                    INFANTES Y AMAS DE LECHE EN LA COLECCIÓN COURRET 
                </p>
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="fontMS500 text-justify font-24 text-gris">
                            <br>
                            La Biblioteca Nacional del Perú resguarda colecciones fotográficas 
                            de gran relevancia para la memoria visual e histórica de nuestro país. 
                            Entre estas destaca la Colección Courret, archivo que testimonia el 
                            trabajo realizado por el estudio Fotografía Central E. Courret y Cía. 
                            Este estudio funcionó en Lima, entre 1863 y 1935. Sus imágenes, 
                            conservadas en negativos de placas de vidrio, registran la vida 
                            social, política y económica del país. Entre esos registros se 
                            encuentran los retratos de niños junto a su ama de leche o de cría, 
                            mujer comúnmente de ascendencia africana. 
        
                        </p>
                        <p class="fontMS500Italic text-right font-24 text-gris mt6">
                            
                            Fachada del Estudio fotográfico Courret, ubicado en Mercaderes 197 
                            (hoy cuadra 3 del Jirón de la Unión). 1905.<br>
                            Adolphe Dubreuil.<br>
                            Negativo sobre placa de vidrio. 24cm. x 18cm. 

        
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <br><br>
                        <a href="https://hdl.handle.net/20.500.14428/54989" target="_blank" style="color: black;">

                        <img class="img-fluid pd-10" width="100%" 
                        src="/assets/images/micrositio/micrositio30/RETRATOS-001.jpg">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            RETRATOS FAMILIARES
                        </p>
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            INFANTES Y AMAS DE LECHE
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row mt-5">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-10 bottom_cel">
                        <p class="fontMS500 text-white text-center font-24 ">
                            En el Perú, la presencia de un ama de leche en las viviendas se remonta 
                            al pasado colonial. Posteriormente, hubo una notoria preferencia por 
                            las nodrizas afroperuanas entre las familias tradicionales y aristocráticas 
                            de Lima, y las familias de inmigrantes extranjeros que llegaron al país 
                            ante la bonanza de la era del guano.
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/247" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-002.jpg">
                        </a>
                        <p class="fontMS300 text-white text-right font-18 pd-10 ">
                            <br>
                            Retrato de Roberto Baudrot y amas. 1896. <br>
                            Adolphe Dubreuil. <br>
                            1 negativo sobre placa de vidrio: gelatino bromuro. <br>
                            18 cm. x 13 cm.<br>
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/24009" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-003.jpg">
                        </a>
                        <p class="fontMS300 text-white text-left font-18 ">
                            <br>
                            Pablo Ascher y ama. 1903. <br>
                            Adolphe Dubreuil. <br>
                            1 negativo sobre placa de vidrio: gelatino bromuro. <br>
                            18 cm. x 13 cm.<br>
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/30377" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-004.jpg">
                        </a>
                        <p class="fontMS300 text-white text-right font-18 pd-10 ">
                            <br>
                            Retrato de Roberto Baudrot y amas. 1896.<br> 
                            Adolphe Dubreuil. <br>
                            1 negativo sobre placa de vidrio: gelatino bromuro. <br>
                            18 cm. x 13 cm.<br>
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/28208" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-005.jpg">
                        </a>
                        <p class="fontMS300 text-white text-left font-18 ">
                            <br>
                            Carlos Brignardello y ama. Sin fecha. <br>
                            Estudio Courret.<br>
                            1 placa de vidrio: byn.<br> 
                            12 cm. x 18 cm.<br>
                        </p>
                    </div>

                    <div class="col-sm-1 "></div>
                </div>
                <br><br>
                            <hr class="text-white">
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            EL ESTUDIO COURRET
                        </p>

                    </div>
                    
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS500 text-center colorPrincipal font-40">
                            Y LA CONSTRUCCIÓN DEL RELATO
                        </p>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-10 bottom_cel">
                        <p class="fontMS500 text-center font-24 ">
                            Los retratos de las amas de leche buscaron transmitir familiaridad y un vínculo 
                            casi maternal entre el niño y su ama. Para lograr ese efecto, los niños eran 
                            ubicados en pedestales, y eran retratados en brazos o sobre el regazo de sus 
                            nodrizas, en medio de una escenografía compuesta por telones neutros o pintados 
                            con arquitecturas simuladas.
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/2973" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-006.jpg">
                        </a>
                        <p class="fontMS300 text-gris text-right font-18 pd-10 ">
                            <br>
                            Henry Frederick Meiggs y ama. 1889. <br>
                            Courret Hermanos. <br>
                            1 negativo sobre placa de vidrio: gelatino brumoso. <br>
                            18 cm. x 13 cm.<br>                        
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/462" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-007.jpg">
                        </a>
                        <p class="fontMS300 text-gris text-left font-18 ">
                            <br>
                            Niña Chaize y ama de cría. 1883. <br>
                            Eugène Courret. <br>
                            1 negativo sobre placa de vidrio: gelatino brumoso. <br>
                            18 cm. x 13 cm.<br>
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/29539" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-008.jpg">
                        </a>
                        <p class="fontMS300 text-gris text-right font-18 pd-10 ">
                            <br>
                            Pedro Alfredo Figari Barúa y ama. 1880. <br>
                            Eugène Courret. <br>
                            1 negativo sobre placa de vidrio.<br>
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/6642" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-009.jpg">
                        </a>
                        <p class="fontMS300 text-gris text-left font-18 ">
                            <br>
                            Pedro Tonesi y ama. 1884. <br>
                            Eugène Courret. 1884. <br>
                            1 placa de vidrio: byn. <br>
                            9 cm. x 12 cm.  <br>
                        </p>
                    </div>

                    <div class="col-sm-1 "></div>
                </div>
                <br><br>
                            <hr>
            </div>
        </div>
    </div>
</div>

<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            MUJERES AFROPERUANAS
                        </p>
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            EN EL PERÚ DEL SIGLO XIX
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row mt-5">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-10 bottom_cel">
                        <p class="fontMS500 text-white text-center font-24 ">
                            En la Colección Courret destacan los rostros de las nodrizas, 
                            mujeres afrodescendientes que, tras la abolición del sistema 
                            esclavista en 1854, buscaron su sustento en actividades como 
                            la lactancia pagada o mercenaria, que les permitió asegurar 
                            dinero para su subsistencia. Esas imágenes llenaron los álbumes 
                            familiares y las tarjetas de visita. 
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>

                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/32803" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-010.jpg">
                        </a>
                        <p class="fontMS300 text-white text-right font-18 pd-10 ">
                            <br>
                            Niña y ama. 18-? <br>
                            No definido. <br>
                            1 negativo sobre placa de vidrio: colodión. <br>
                            18 cm. x 13 cm.        <br>                
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/28257" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-011.jpg">
                        </a>
                        <p class="fontMS300 text-white text-left font-18 ">
                            <br>
                            René Melot y ama. 1912.<br>
                            Adolphe Dubreuil. <br>
                            1 negativo sobre placa de vidrio: gelatino bromuro. <br>
                            18 cm. x 13 cm. <br>
                        </p>
                    </div>
                    <div class="col-sm-1 "></div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-1 "></div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/31963" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-012.jpg">
                        </a>
                        <p class="fontMS300 text-white text-right font-18 pd-10 ">
                            <br>
                            Renzo Bracesco. 1891. <br>Eugène Courret. <br>
                            1 negativo sobre placa de vidrio: gelatino bromuro. <br>
                            18 cm. x 13 cm. <br>
                        </p>
                    </div>
                    <div class="col-sm-5">
                        <a href="https://hdl.handle.net/20.500.14428/10099" target="_blank" style="color: black;">
                            <img class="img-fluid pd-10" width="100%" 
                            src="/assets/images/micrositio/micrositio30/RETRATOS-013.jpg">
                        </a>
                        <p class="fontMS300 text-white text-left font-18 ">
                            <br>
                            Melanie Cocle y ama. 1884. <br>No definido. <br>1 placa de vidrio: byn. <br>9 cm. x 12 cm. 
                        </p>
                    </div>

                    <div class="col-sm-1 "></div>
                </div>
                <br><br>
                            <hr class="text-white">
            </div>
        </div>
    </div>
</div>



<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio30/RETRATOS-LINEA-000.png" width="100%">
                <p class="fontMS500 text-justify font-22 text-gris" >
                    <br>
                    LAS IMÁGENES MOSTRADAS PERMITEN APRECIAR UNA ANTIGUA PRÁCTICA DE SERVIDUMBRE 
                    EN LA LIMA DEL SIGLO XIX, Y CONOCER, ADEMÁS, LAS RELACIONES INTERRACIALES, 
                    AFECTIVAS, DE GÉNERO Y CULTURALES QUE CUMPLIÓ LA MUJER AFROPERUANA EN DICHA 
                    SOCIEDAD. DEL MISMO MODO, NOS ACERCA A SU COTIDIANEIDAD, VITALIDAD, LUCHAS 
                    Y RESISTENCIA. 
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio30/RETRATOS-LINEA-000.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>




<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">

                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 200%;margin-top: 10%;"
                            class="fontMS700 text-center font-40 colorPrincipal bottom_cel">
                            PARA SABER MÁS
                        </p>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40 colorPrincipal c100">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">

                    </div>
                </div>
                <p class="fontMS100 font-24">

                </p>
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="font-24 ">
                            <br>
                            <span class="fontMS500">
                                Estela, C. (2021).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                La sociedad de vidrio. El fotógrafo migrante Eugène Courret y la construcción de la memoria visual y las identidades en Perú durante la segunda mitad del siglo XIX. Artelogie, Vol. 16.  Disponible en: 
                                <br></span>
                            <span class="text-gris" style="word-wrap: break-word;">
                                https://journals.openedition.org/artelogie/8872?lang=en                            </span><br>
                            <a href="https://journals.openedition.org/artelogie/8872?lang=en" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24 ">
                            <br>
                            <span class="fontMS500">
                                Schwarz, H. (2017).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Estudio Courret. Historia de la fotografía en Lima. 
                                Lima: Municipalidad Metropolitana de Lima. 
                                <br></span>
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Rosas, C. (2005). 
                            </span><br>
                            <span class="fontMS100 text-gris">
                                La visión ilustrada de las amas de leche negras y mulatas 
                                en el ámbito familiar (Lima, siglo XVIII). En: O´Phelan y Salazar-Soler, 
                                C. (eds.). Passeurs, mediadores culturales y agentes de la primera 
                                globalización en el Mundo Ibérico, siglos XVI-XIX. Lima: Pontificia 
                                Universidad Católica del Perú, Instituto Riva-Agüero, Instituto 
                                Francés de Estudios Andinos, p. 311-343.  
                            </span>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Villegas, F. y Torres, J. E. (2005).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Imágenes trasgredidas. Retrato y fotografía 
                                en Lima: 1842-1920. Illapa. No. 2, p. 39-56.
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->
